import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const dialpad = defineConnector({
  identifier: "dialpad",
  name: "Dialpad",
  tagLine: "AI-powered business communications",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://dialpad\\.com/api/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to your [Dialpad](https://dialpad.com/) admin account. Navigate to **Admin Settings → Company Settings → API Keys** to generate a new API key.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://dialpad.com/api/v2/users/me",
  },
});
